import { createStyles } from 'antd-style';

export const useStyles = createStyles(({ token, css, responsive }) => {
  return {
    container: css`
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    `,
    input: css`
      width: 58px;
      margin: 0px 5px;

      font-size: 18px;
      line-height: 45px;
      text-align: center;

      border-radius: 12px;
      border: 1px solid #989898;
      &:focus {
        border-color: ${token.colorPrimary};
      }
      ${responsive.mobile} {
        width: calc((100% - 30px) / 6);
        line-height: 40px;
      }
    `,
    titleWrap: css`
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
    `,
    title: css``,
    titleRequire: css`
      &::before {
        display: inline-block;
        margin-inline-end: 4px;
        color: #ff4d4f;
        font-size: 14px;
        font-family: SimSun, sans-serif;
        line-height: 1;
        content: '*';
      }
    `,
    error: css`
      border-color: ${token.colorError};
    `
  };
});
